import * as React from "react"
import { Grid, Typography } from "@mui/material"
import { TourTarget } from "@tour"

import { priceChangesIsEmpty } from "./@signals"
import PriceChangesPriceEvolutionChart from "./PriceEvolutionChart"
import PricingChangesTable from "./Table"
import PricingChangesWidget from "./Widget"
import CreateReportButton from "./Table/actions/CreateReportButton"
import PriceChangeReportFormDrawer from "./Form"
import {useUserApp} from "../../../@hooks";


export default function PricingChangesContent() {
    const { userUseRRSP } = useUserApp()
    if (priceChangesIsEmpty.value) 
        return <Typography variant="h5" sx={{ mt: 4, textAlign: 'center'}}> Mmmm, it seems like the prices haven’t moved much during the selected dates. </Typography>

    return <Grid container spacing={2}>
        {!!userUseRRSP && <Grid item xs={12} data-tour="pricing-changes-widgets">
            <PricingChangesWidget />
        </Grid>}

        <Grid item xs={12} sx={{ position: "relative" }}>
            <TourTarget name="pricing-changes-table" height={350} />
            <PricingChangesTable />
        </Grid>

        <Grid item xs={12}>
            <PriceChangesPriceEvolutionChart />
        </Grid>
        <Grid item xs={12}>
            <PriceChangeReportFormDrawer />
        </Grid>
    </Grid>
}